import React, { FC, useState, useImperativeHandle } from 'react';
import { Popup } from 'antd-mobile';
import { $vw } from '@/utils';
import { share } from '@haidilao-private/jsbridge';
import './index.scss';
interface propsType {
  cRef?: any;
  shareUrl: string;
  image: string;
}
type Platform = 'wx' | 'wxzone' | 'qq' | 'qqzone' | 'copy' | 'weibo';
const Error: FC<propsType> = (props) => {
  const { cRef, shareUrl, image } = props;
  const [visible1, setVisible1] = useState<boolean>(false);
  const bodyStyle = {
    width: '100%',
    height: $vw(213),
    background: '#ffffff',
    borderRadius: `${$vw(8)} ${$vw(8)} 0 0`,
  };
  /**
   * @description: 切换弹框状态
   */
  const open = () => {
    setVisible1(true);
  };
  /**
   * @description: 关闭
   */
  const close = () => {
    setVisible1(false);
  };
  /**
   * @description: 设置分享
   */
  const handlerShare = (platform: Platform) => {
    share(
      {
        type: 'web',
        sharePageUrl: shareUrl,
        title: '来海底捞签到啦~',
        platform: platform,
        image,
        content: '海底捞签到有礼，天天有惊喜日日享福利',
      },
      (res: any) => {
        console.log(`分享结果${res}`);
      },
    );
    close();
  };
  /**
   * @description: 绑定ref
   */
  useImperativeHandle(cRef, () => ({
    open,
  }));
  return (
    <Popup
      visible={visible1}
      onMaskClick={() => {
        setVisible1(false);
      }}
      bodyStyle={bodyStyle}
    >
      <div className="share">
        {/* 分享类型 */}
        <div className="share__type">
          <div className="share__item" onClick={() => handlerShare('wx')}>
            <img src={require('@/images/share/icon_wx.png')} alt="" />
            <p>微信好友</p>
          </div>
          <div className="share__item" onClick={() => handlerShare('wxzone')}>
            <img src={require('@/images/share/icon_pyq.png')} alt="" />
            <p>朋友圈</p>
          </div>
        </div>
        {/* 分享按钮 */}
        <div className="share__btn" onClick={close}>
          取消
        </div>
      </div>
    </Popup>
  );
};
export default Error;
